import React, { Component } from "react";
import NewUIOffer from "./offerV3";
import classnames from "classnames";
import { sendWW } from "../../../service";
import Util from "../../../pages/util/common"

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

class Offer extends Component {
  constructor(props) {
    super(props);
    this.wwClick = this.wwClick.bind(this);
  }
  componentDidMount() {
    const { data } = this.props;
    let { imgUrl } = data;
    if (imgUrl.indexOf("cbu01.alicdn.com") > -1) {
      data.imgUrl = `${imgUrl.replace(".jpg", ".220x220.jpg")}?_=2020`;
    }
  }
  wwClick() {
    const { data } = this.props;
    const isP4p = data.isP4p || data.isP4p ? 1 : 0;
    const { exp } = pageConfig;
    let expParams = getExpParams(exp || "");
    window.Light && window.Light.setup({
      beforeOpenClient: (_targetElement, urlParamObj, next) => {
        urlParamObj.sourceValue = encodeURIComponent(
          JSON.stringify({
            sourceType: "pcOD",
            targetLoginId: data.loginId,
            source: "od",
            offerId: data.offerid,
            orderId: "",
            adClickId: Util.getUrlParam('clickid'),
            extra: { cosite: Util.getUrlParam('cosite'), pid: Util.getUrlParam('pid'), ptid: Util.getUrlParam('ptid') },
          })
        );
        next(urlParamObj);
      },
    });
    if (Util.getCookie("__cn_logon_id__") && isP4p && expParams.pcSemWwClick === "B") {
      sendWW(data.eurl, data.offerid, "user_trigger")
    }
  }
  render() {
    const { data, index, buyerTags, idx } = this.props;
    let cbu_ad_sessionid = "";
    let cbu_ad_adgroup_id = "";
    const isP4p = data.isP4p || data.isP4p ? 1 : 0;

    const style = {
      height: "360px",
      width: "222px",
      boxSizing: "border-box",
      position: "relative",
      marginRight: "11px",
      marginBottom: "11px",
    };

    data.isPcSem = true;
    // delete data.loginId
    //添加打点参数
    let { trackInfo } = data;
    if (trackInfo && typeof trackInfo === "string") {
      trackInfo = JSON.parse(trackInfo);
    } else if (!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

    
    return (
      <div
        className={classnames({offer_exp: data.impressionEurl})}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${data.offerId}^_p_isad@${isP4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}`}
        style={style}
      >
        <NewUIOffer data={data} buyerTags={buyerTags} idx={idx} wwClick={this.wwClick} />
      </div>
    );
  }
}

export default Offer;
